export const labelTypeMixin = {
  props: {
    labeltype: {
      default: function () {
        return "default"
      },
      validator: function (value) {
        const available = ["default", "small", "grey"]

        return available.includes(value)
      },
      type: String,
    },
  },
}
